import { render, staticRenderFns } from "./BookletView.vue?vue&type=template&id=58ae084e&"
import script from "./BookletView.vue?vue&type=script&lang=ts&"
export * from "./BookletView.vue?vue&type=script&lang=ts&"
import style0 from "./BookletView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports